export const SET_PARTICIPANT = 'PARTICIPANT/SET_PARTICIPANT'
